"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MsgClientImpl = exports.MsgUpdateGroupedTokenConfigResponse = exports.UpdateGroupedTokenConfigParams = exports.MsgUpdateGroupedTokenConfig = exports.MsgWithdrawFromGroupResponse = exports.MsgWithdrawFromGroup = exports.MsgDepositToGroupResponse = exports.MsgDepositToGroup = exports.MsgDeregisterFromGroupResponse = exports.MsgDeregisterFromGroup = exports.MsgRegisterToGroupResponse = exports.MsgRegisterToGroup = exports.MsgUpdateGroupResponse = exports.UpdateGroupParams = exports.MsgUpdateGroup = exports.MsgCreateGroupResponse = exports.MsgCreateGroup = exports.MsgRemoveBridgeAddressResponse = exports.MsgRemoveBridgeAddress = exports.MsgAddBridgeAddressResponse = exports.MsgAddBridgeAddress = exports.MsgUpdateTokenResponse = exports.UpdateTokenParams = exports.MsgUpdateToken = exports.MsgRemoveBridgeResponse = exports.MsgRemoveBridge = exports.MsgEditBridgeNameResponse = exports.MsgEditBridgeName = exports.MsgDeauthorizeBridgeResponse = exports.MsgDeauthorizeBridge = exports.MsgAuthorizeBridgeResponse = exports.MsgAuthorizeBridge = exports.MsgWithdrawResponse = exports.MsgWithdraw = exports.MsgLinkTokenResponse = exports.MsgLinkToken = exports.MsgUnbindTokenResponse = exports.MsgUnbindToken = exports.MsgBindTokenResponse = exports.MsgBindToken = exports.MsgMintTokenResponse = exports.MsgMintToken = exports.MsgSyncTokenResponse = exports.MsgSyncToken = exports.MsgCreateTokenResponse = exports.CreateTokenParams = exports.MsgCreateToken = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const bridge_1 = require("./bridge");
const group_1 = require("./group");
const coin_1 = require("../../../cosmos/base/v1beta1/coin");
const wrappers_1 = require("../../../google/protobuf/wrappers");
exports.protobufPackage = "Switcheo.carbon.coin";
const baseMsgCreateToken = { creator: "" };
exports.MsgCreateToken = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.createTokenParams !== undefined) {
            exports.CreateTokenParams.encode(message.createTokenParams, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgCreateToken);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.createTokenParams = exports.CreateTokenParams.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgCreateToken);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.createTokenParams =
            object.createTokenParams !== undefined &&
                object.createTokenParams !== null
                ? exports.CreateTokenParams.fromJSON(object.createTokenParams)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.createTokenParams !== undefined &&
            (obj.createTokenParams = message.createTokenParams
                ? exports.CreateTokenParams.toJSON(message.createTokenParams)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseMsgCreateToken);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.createTokenParams =
            object.createTokenParams !== undefined &&
                object.createTokenParams !== null
                ? exports.CreateTokenParams.fromPartial(object.createTokenParams)
                : undefined;
        return message;
    },
};
const baseCreateTokenParams = {
    creator: "",
    name: "",
    symbol: "",
    decimals: long_1.default.ZERO,
    chainId: long_1.default.UZERO,
    bridgeId: long_1.default.UZERO,
    bridgeAddress: "",
    tokenAddress: "",
};
exports.CreateTokenParams = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.name !== "") {
            writer.uint32(18).string(message.name);
        }
        if (message.symbol !== "") {
            writer.uint32(26).string(message.symbol);
        }
        if (!message.decimals.isZero()) {
            writer.uint32(32).int64(message.decimals);
        }
        if (!message.chainId.isZero()) {
            writer.uint32(40).uint64(message.chainId);
        }
        if (!message.bridgeId.isZero()) {
            writer.uint32(48).uint64(message.bridgeId);
        }
        if (message.bridgeAddress !== "") {
            writer.uint32(58).string(message.bridgeAddress);
        }
        if (message.tokenAddress !== "") {
            writer.uint32(66).string(message.tokenAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseCreateTokenParams);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.name = reader.string();
                    break;
                case 3:
                    message.symbol = reader.string();
                    break;
                case 4:
                    message.decimals = reader.int64();
                    break;
                case 5:
                    message.chainId = reader.uint64();
                    break;
                case 6:
                    message.bridgeId = reader.uint64();
                    break;
                case 7:
                    message.bridgeAddress = reader.string();
                    break;
                case 8:
                    message.tokenAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseCreateTokenParams);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.name =
            object.name !== undefined && object.name !== null
                ? String(object.name)
                : "";
        message.symbol =
            object.symbol !== undefined && object.symbol !== null
                ? String(object.symbol)
                : "";
        message.decimals =
            object.decimals !== undefined && object.decimals !== null
                ? long_1.default.fromString(object.decimals)
                : long_1.default.ZERO;
        message.chainId =
            object.chainId !== undefined && object.chainId !== null
                ? long_1.default.fromString(object.chainId)
                : long_1.default.UZERO;
        message.bridgeId =
            object.bridgeId !== undefined && object.bridgeId !== null
                ? long_1.default.fromString(object.bridgeId)
                : long_1.default.UZERO;
        message.bridgeAddress =
            object.bridgeAddress !== undefined && object.bridgeAddress !== null
                ? String(object.bridgeAddress)
                : "";
        message.tokenAddress =
            object.tokenAddress !== undefined && object.tokenAddress !== null
                ? String(object.tokenAddress)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.name !== undefined && (obj.name = message.name);
        message.symbol !== undefined && (obj.symbol = message.symbol);
        message.decimals !== undefined &&
            (obj.decimals = (message.decimals || long_1.default.ZERO).toString());
        message.chainId !== undefined &&
            (obj.chainId = (message.chainId || long_1.default.UZERO).toString());
        message.bridgeId !== undefined &&
            (obj.bridgeId = (message.bridgeId || long_1.default.UZERO).toString());
        message.bridgeAddress !== undefined &&
            (obj.bridgeAddress = message.bridgeAddress);
        message.tokenAddress !== undefined &&
            (obj.tokenAddress = message.tokenAddress);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = Object.assign({}, baseCreateTokenParams);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.name = (_b = object.name) !== null && _b !== void 0 ? _b : "";
        message.symbol = (_c = object.symbol) !== null && _c !== void 0 ? _c : "";
        message.decimals =
            object.decimals !== undefined && object.decimals !== null
                ? long_1.default.fromValue(object.decimals)
                : long_1.default.ZERO;
        message.chainId =
            object.chainId !== undefined && object.chainId !== null
                ? long_1.default.fromValue(object.chainId)
                : long_1.default.UZERO;
        message.bridgeId =
            object.bridgeId !== undefined && object.bridgeId !== null
                ? long_1.default.fromValue(object.bridgeId)
                : long_1.default.UZERO;
        message.bridgeAddress = (_d = object.bridgeAddress) !== null && _d !== void 0 ? _d : "";
        message.tokenAddress = (_e = object.tokenAddress) !== null && _e !== void 0 ? _e : "";
        return message;
    },
};
const baseMsgCreateTokenResponse = { denom: "" };
exports.MsgCreateTokenResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.denom !== "") {
            writer.uint32(10).string(message.denom);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgCreateTokenResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.denom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgCreateTokenResponse);
        message.denom =
            object.denom !== undefined && object.denom !== null
                ? String(object.denom)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseMsgCreateTokenResponse);
        message.denom = (_a = object.denom) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseMsgSyncToken = { syncer: "", denom: "" };
exports.MsgSyncToken = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.syncer !== "") {
            writer.uint32(10).string(message.syncer);
        }
        if (message.denom !== "") {
            writer.uint32(18).string(message.denom);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSyncToken);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.syncer = reader.string();
                    break;
                case 2:
                    message.denom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgSyncToken);
        message.syncer =
            object.syncer !== undefined && object.syncer !== null
                ? String(object.syncer)
                : "";
        message.denom =
            object.denom !== undefined && object.denom !== null
                ? String(object.denom)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.syncer !== undefined && (obj.syncer = message.syncer);
        message.denom !== undefined && (obj.denom = message.denom);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseMsgSyncToken);
        message.syncer = (_a = object.syncer) !== null && _a !== void 0 ? _a : "";
        message.denom = (_b = object.denom) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseMsgSyncTokenResponse = {};
exports.MsgSyncTokenResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSyncTokenResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgSyncTokenResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgSyncTokenResponse);
        return message;
    },
};
const baseMsgMintToken = { creator: "", denom: "", amount: "", to: "" };
exports.MsgMintToken = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.denom !== "") {
            writer.uint32(18).string(message.denom);
        }
        if (message.amount !== "") {
            writer.uint32(26).string(message.amount);
        }
        if (message.to !== "") {
            writer.uint32(34).string(message.to);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgMintToken);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.denom = reader.string();
                    break;
                case 3:
                    message.amount = reader.string();
                    break;
                case 4:
                    message.to = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgMintToken);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.denom =
            object.denom !== undefined && object.denom !== null
                ? String(object.denom)
                : "";
        message.amount =
            object.amount !== undefined && object.amount !== null
                ? String(object.amount)
                : "";
        message.to =
            object.to !== undefined && object.to !== null ? String(object.to) : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.denom !== undefined && (obj.denom = message.denom);
        message.amount !== undefined && (obj.amount = message.amount);
        message.to !== undefined && (obj.to = message.to);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = Object.assign({}, baseMsgMintToken);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.denom = (_b = object.denom) !== null && _b !== void 0 ? _b : "";
        message.amount = (_c = object.amount) !== null && _c !== void 0 ? _c : "";
        message.to = (_d = object.to) !== null && _d !== void 0 ? _d : "";
        return message;
    },
};
const baseMsgMintTokenResponse = {};
exports.MsgMintTokenResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgMintTokenResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgMintTokenResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgMintTokenResponse);
        return message;
    },
};
const baseMsgBindToken = {
    creator: "",
    sourceDenom: "",
    wrappedDenom: "",
};
exports.MsgBindToken = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.sourceDenom !== "") {
            writer.uint32(18).string(message.sourceDenom);
        }
        if (message.wrappedDenom !== "") {
            writer.uint32(26).string(message.wrappedDenom);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgBindToken);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.sourceDenom = reader.string();
                    break;
                case 3:
                    message.wrappedDenom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgBindToken);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.sourceDenom =
            object.sourceDenom !== undefined && object.sourceDenom !== null
                ? String(object.sourceDenom)
                : "";
        message.wrappedDenom =
            object.wrappedDenom !== undefined && object.wrappedDenom !== null
                ? String(object.wrappedDenom)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.sourceDenom !== undefined &&
            (obj.sourceDenom = message.sourceDenom);
        message.wrappedDenom !== undefined &&
            (obj.wrappedDenom = message.wrappedDenom);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = Object.assign({}, baseMsgBindToken);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.sourceDenom = (_b = object.sourceDenom) !== null && _b !== void 0 ? _b : "";
        message.wrappedDenom = (_c = object.wrappedDenom) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
const baseMsgBindTokenResponse = {};
exports.MsgBindTokenResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgBindTokenResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgBindTokenResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgBindTokenResponse);
        return message;
    },
};
const baseMsgUnbindToken = { creator: "", wrappedDenom: "" };
exports.MsgUnbindToken = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.wrappedDenom !== "") {
            writer.uint32(18).string(message.wrappedDenom);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUnbindToken);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.wrappedDenom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgUnbindToken);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.wrappedDenom =
            object.wrappedDenom !== undefined && object.wrappedDenom !== null
                ? String(object.wrappedDenom)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.wrappedDenom !== undefined &&
            (obj.wrappedDenom = message.wrappedDenom);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseMsgUnbindToken);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.wrappedDenom = (_b = object.wrappedDenom) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseMsgUnbindTokenResponse = {};
exports.MsgUnbindTokenResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUnbindTokenResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgUnbindTokenResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgUnbindTokenResponse);
        return message;
    },
};
const baseMsgLinkToken = { creator: "", denom: "", bridgeAddress: "" };
exports.MsgLinkToken = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.denom !== "") {
            writer.uint32(18).string(message.denom);
        }
        if (message.bridgeAddress !== "") {
            writer.uint32(26).string(message.bridgeAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgLinkToken);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.denom = reader.string();
                    break;
                case 3:
                    message.bridgeAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgLinkToken);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.denom =
            object.denom !== undefined && object.denom !== null
                ? String(object.denom)
                : "";
        message.bridgeAddress =
            object.bridgeAddress !== undefined && object.bridgeAddress !== null
                ? String(object.bridgeAddress)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.denom !== undefined && (obj.denom = message.denom);
        message.bridgeAddress !== undefined &&
            (obj.bridgeAddress = message.bridgeAddress);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = Object.assign({}, baseMsgLinkToken);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.denom = (_b = object.denom) !== null && _b !== void 0 ? _b : "";
        message.bridgeAddress = (_c = object.bridgeAddress) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
const baseMsgLinkTokenResponse = {};
exports.MsgLinkTokenResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgLinkTokenResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgLinkTokenResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgLinkTokenResponse);
        return message;
    },
};
const baseMsgWithdraw = {
    creator: "",
    toAddress: "",
    denom: "",
    amount: "",
    feeAmount: "",
    feeAddress: "",
    feeDenom: "",
};
exports.MsgWithdraw = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.toAddress !== "") {
            writer.uint32(18).string(message.toAddress);
        }
        if (message.denom !== "") {
            writer.uint32(26).string(message.denom);
        }
        if (message.amount !== "") {
            writer.uint32(34).string(message.amount);
        }
        if (message.feeAmount !== "") {
            writer.uint32(42).string(message.feeAmount);
        }
        if (message.feeAddress !== "") {
            writer.uint32(50).string(message.feeAddress);
        }
        if (message.feeDenom !== "") {
            writer.uint32(58).string(message.feeDenom);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgWithdraw);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.toAddress = reader.string();
                    break;
                case 3:
                    message.denom = reader.string();
                    break;
                case 4:
                    message.amount = reader.string();
                    break;
                case 5:
                    message.feeAmount = reader.string();
                    break;
                case 6:
                    message.feeAddress = reader.string();
                    break;
                case 7:
                    message.feeDenom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgWithdraw);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.toAddress =
            object.toAddress !== undefined && object.toAddress !== null
                ? String(object.toAddress)
                : "";
        message.denom =
            object.denom !== undefined && object.denom !== null
                ? String(object.denom)
                : "";
        message.amount =
            object.amount !== undefined && object.amount !== null
                ? String(object.amount)
                : "";
        message.feeAmount =
            object.feeAmount !== undefined && object.feeAmount !== null
                ? String(object.feeAmount)
                : "";
        message.feeAddress =
            object.feeAddress !== undefined && object.feeAddress !== null
                ? String(object.feeAddress)
                : "";
        message.feeDenom =
            object.feeDenom !== undefined && object.feeDenom !== null
                ? String(object.feeDenom)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.toAddress !== undefined && (obj.toAddress = message.toAddress);
        message.denom !== undefined && (obj.denom = message.denom);
        message.amount !== undefined && (obj.amount = message.amount);
        message.feeAmount !== undefined && (obj.feeAmount = message.feeAmount);
        message.feeAddress !== undefined && (obj.feeAddress = message.feeAddress);
        message.feeDenom !== undefined && (obj.feeDenom = message.feeDenom);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g;
        const message = Object.assign({}, baseMsgWithdraw);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.toAddress = (_b = object.toAddress) !== null && _b !== void 0 ? _b : "";
        message.denom = (_c = object.denom) !== null && _c !== void 0 ? _c : "";
        message.amount = (_d = object.amount) !== null && _d !== void 0 ? _d : "";
        message.feeAmount = (_e = object.feeAmount) !== null && _e !== void 0 ? _e : "";
        message.feeAddress = (_f = object.feeAddress) !== null && _f !== void 0 ? _f : "";
        message.feeDenom = (_g = object.feeDenom) !== null && _g !== void 0 ? _g : "";
        return message;
    },
};
const baseMsgWithdrawResponse = {};
exports.MsgWithdrawResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgWithdrawResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgWithdrawResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgWithdrawResponse);
        return message;
    },
};
const baseMsgAuthorizeBridge = {
    creator: "",
    bridgeId: long_1.default.UZERO,
    chainId: long_1.default.UZERO,
    chainName: "",
};
exports.MsgAuthorizeBridge = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (!message.bridgeId.isZero()) {
            writer.uint32(16).uint64(message.bridgeId);
        }
        if (!message.chainId.isZero()) {
            writer.uint32(24).uint64(message.chainId);
        }
        if (message.chainName !== "") {
            writer.uint32(34).string(message.chainName);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgAuthorizeBridge);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.bridgeId = reader.uint64();
                    break;
                case 3:
                    message.chainId = reader.uint64();
                    break;
                case 4:
                    message.chainName = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgAuthorizeBridge);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.bridgeId =
            object.bridgeId !== undefined && object.bridgeId !== null
                ? long_1.default.fromString(object.bridgeId)
                : long_1.default.UZERO;
        message.chainId =
            object.chainId !== undefined && object.chainId !== null
                ? long_1.default.fromString(object.chainId)
                : long_1.default.UZERO;
        message.chainName =
            object.chainName !== undefined && object.chainName !== null
                ? String(object.chainName)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.bridgeId !== undefined &&
            (obj.bridgeId = (message.bridgeId || long_1.default.UZERO).toString());
        message.chainId !== undefined &&
            (obj.chainId = (message.chainId || long_1.default.UZERO).toString());
        message.chainName !== undefined && (obj.chainName = message.chainName);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseMsgAuthorizeBridge);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.bridgeId =
            object.bridgeId !== undefined && object.bridgeId !== null
                ? long_1.default.fromValue(object.bridgeId)
                : long_1.default.UZERO;
        message.chainId =
            object.chainId !== undefined && object.chainId !== null
                ? long_1.default.fromValue(object.chainId)
                : long_1.default.UZERO;
        message.chainName = (_b = object.chainName) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseMsgAuthorizeBridgeResponse = { id: "" };
exports.MsgAuthorizeBridgeResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (message.bridge !== undefined) {
            bridge_1.Bridge.encode(message.bridge, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgAuthorizeBridgeResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.bridge = bridge_1.Bridge.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgAuthorizeBridgeResponse);
        message.id =
            object.id !== undefined && object.id !== null ? String(object.id) : "";
        message.bridge =
            object.bridge !== undefined && object.bridge !== null
                ? bridge_1.Bridge.fromJSON(object.bridge)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.id !== undefined && (obj.id = message.id);
        message.bridge !== undefined &&
            (obj.bridge = message.bridge ? bridge_1.Bridge.toJSON(message.bridge) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseMsgAuthorizeBridgeResponse);
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : "";
        message.bridge =
            object.bridge !== undefined && object.bridge !== null
                ? bridge_1.Bridge.fromPartial(object.bridge)
                : undefined;
        return message;
    },
};
const baseMsgDeauthorizeBridge = {
    initiator: "",
    bridgeId: long_1.default.UZERO,
    chainId: long_1.default.UZERO,
};
exports.MsgDeauthorizeBridge = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.initiator !== "") {
            writer.uint32(10).string(message.initiator);
        }
        if (!message.bridgeId.isZero()) {
            writer.uint32(16).uint64(message.bridgeId);
        }
        if (!message.chainId.isZero()) {
            writer.uint32(24).uint64(message.chainId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgDeauthorizeBridge);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.initiator = reader.string();
                    break;
                case 2:
                    message.bridgeId = reader.uint64();
                    break;
                case 3:
                    message.chainId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgDeauthorizeBridge);
        message.initiator =
            object.initiator !== undefined && object.initiator !== null
                ? String(object.initiator)
                : "";
        message.bridgeId =
            object.bridgeId !== undefined && object.bridgeId !== null
                ? long_1.default.fromString(object.bridgeId)
                : long_1.default.UZERO;
        message.chainId =
            object.chainId !== undefined && object.chainId !== null
                ? long_1.default.fromString(object.chainId)
                : long_1.default.UZERO;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.initiator !== undefined && (obj.initiator = message.initiator);
        message.bridgeId !== undefined &&
            (obj.bridgeId = (message.bridgeId || long_1.default.UZERO).toString());
        message.chainId !== undefined &&
            (obj.chainId = (message.chainId || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseMsgDeauthorizeBridge);
        message.initiator = (_a = object.initiator) !== null && _a !== void 0 ? _a : "";
        message.bridgeId =
            object.bridgeId !== undefined && object.bridgeId !== null
                ? long_1.default.fromValue(object.bridgeId)
                : long_1.default.UZERO;
        message.chainId =
            object.chainId !== undefined && object.chainId !== null
                ? long_1.default.fromValue(object.chainId)
                : long_1.default.UZERO;
        return message;
    },
};
const baseMsgDeauthorizeBridgeResponse = { id: "" };
exports.MsgDeauthorizeBridgeResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (message.bridge !== undefined) {
            bridge_1.Bridge.encode(message.bridge, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgDeauthorizeBridgeResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.bridge = bridge_1.Bridge.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgDeauthorizeBridgeResponse);
        message.id =
            object.id !== undefined && object.id !== null ? String(object.id) : "";
        message.bridge =
            object.bridge !== undefined && object.bridge !== null
                ? bridge_1.Bridge.fromJSON(object.bridge)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.id !== undefined && (obj.id = message.id);
        message.bridge !== undefined &&
            (obj.bridge = message.bridge ? bridge_1.Bridge.toJSON(message.bridge) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseMsgDeauthorizeBridgeResponse);
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : "";
        message.bridge =
            object.bridge !== undefined && object.bridge !== null
                ? bridge_1.Bridge.fromPartial(object.bridge)
                : undefined;
        return message;
    },
};
const baseMsgEditBridgeName = {
    initiator: "",
    bridgeId: long_1.default.UZERO,
    chainId: long_1.default.UZERO,
    newBridgeName: "",
};
exports.MsgEditBridgeName = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.initiator !== "") {
            writer.uint32(10).string(message.initiator);
        }
        if (!message.bridgeId.isZero()) {
            writer.uint32(16).uint64(message.bridgeId);
        }
        if (!message.chainId.isZero()) {
            writer.uint32(24).uint64(message.chainId);
        }
        if (message.newBridgeName !== "") {
            writer.uint32(34).string(message.newBridgeName);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgEditBridgeName);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.initiator = reader.string();
                    break;
                case 2:
                    message.bridgeId = reader.uint64();
                    break;
                case 3:
                    message.chainId = reader.uint64();
                    break;
                case 4:
                    message.newBridgeName = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgEditBridgeName);
        message.initiator =
            object.initiator !== undefined && object.initiator !== null
                ? String(object.initiator)
                : "";
        message.bridgeId =
            object.bridgeId !== undefined && object.bridgeId !== null
                ? long_1.default.fromString(object.bridgeId)
                : long_1.default.UZERO;
        message.chainId =
            object.chainId !== undefined && object.chainId !== null
                ? long_1.default.fromString(object.chainId)
                : long_1.default.UZERO;
        message.newBridgeName =
            object.newBridgeName !== undefined && object.newBridgeName !== null
                ? String(object.newBridgeName)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.initiator !== undefined && (obj.initiator = message.initiator);
        message.bridgeId !== undefined &&
            (obj.bridgeId = (message.bridgeId || long_1.default.UZERO).toString());
        message.chainId !== undefined &&
            (obj.chainId = (message.chainId || long_1.default.UZERO).toString());
        message.newBridgeName !== undefined &&
            (obj.newBridgeName = message.newBridgeName);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseMsgEditBridgeName);
        message.initiator = (_a = object.initiator) !== null && _a !== void 0 ? _a : "";
        message.bridgeId =
            object.bridgeId !== undefined && object.bridgeId !== null
                ? long_1.default.fromValue(object.bridgeId)
                : long_1.default.UZERO;
        message.chainId =
            object.chainId !== undefined && object.chainId !== null
                ? long_1.default.fromValue(object.chainId)
                : long_1.default.UZERO;
        message.newBridgeName = (_b = object.newBridgeName) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseMsgEditBridgeNameResponse = { id: "" };
exports.MsgEditBridgeNameResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (message.bridge !== undefined) {
            bridge_1.Bridge.encode(message.bridge, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgEditBridgeNameResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.bridge = bridge_1.Bridge.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgEditBridgeNameResponse);
        message.id =
            object.id !== undefined && object.id !== null ? String(object.id) : "";
        message.bridge =
            object.bridge !== undefined && object.bridge !== null
                ? bridge_1.Bridge.fromJSON(object.bridge)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.id !== undefined && (obj.id = message.id);
        message.bridge !== undefined &&
            (obj.bridge = message.bridge ? bridge_1.Bridge.toJSON(message.bridge) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseMsgEditBridgeNameResponse);
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : "";
        message.bridge =
            object.bridge !== undefined && object.bridge !== null
                ? bridge_1.Bridge.fromPartial(object.bridge)
                : undefined;
        return message;
    },
};
const baseMsgRemoveBridge = {
    initiator: "",
    bridgeId: long_1.default.UZERO,
    chainId: long_1.default.UZERO,
};
exports.MsgRemoveBridge = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.initiator !== "") {
            writer.uint32(10).string(message.initiator);
        }
        if (!message.bridgeId.isZero()) {
            writer.uint32(16).uint64(message.bridgeId);
        }
        if (!message.chainId.isZero()) {
            writer.uint32(24).uint64(message.chainId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgRemoveBridge);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.initiator = reader.string();
                    break;
                case 2:
                    message.bridgeId = reader.uint64();
                    break;
                case 3:
                    message.chainId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgRemoveBridge);
        message.initiator =
            object.initiator !== undefined && object.initiator !== null
                ? String(object.initiator)
                : "";
        message.bridgeId =
            object.bridgeId !== undefined && object.bridgeId !== null
                ? long_1.default.fromString(object.bridgeId)
                : long_1.default.UZERO;
        message.chainId =
            object.chainId !== undefined && object.chainId !== null
                ? long_1.default.fromString(object.chainId)
                : long_1.default.UZERO;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.initiator !== undefined && (obj.initiator = message.initiator);
        message.bridgeId !== undefined &&
            (obj.bridgeId = (message.bridgeId || long_1.default.UZERO).toString());
        message.chainId !== undefined &&
            (obj.chainId = (message.chainId || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseMsgRemoveBridge);
        message.initiator = (_a = object.initiator) !== null && _a !== void 0 ? _a : "";
        message.bridgeId =
            object.bridgeId !== undefined && object.bridgeId !== null
                ? long_1.default.fromValue(object.bridgeId)
                : long_1.default.UZERO;
        message.chainId =
            object.chainId !== undefined && object.chainId !== null
                ? long_1.default.fromValue(object.chainId)
                : long_1.default.UZERO;
        return message;
    },
};
const baseMsgRemoveBridgeResponse = {};
exports.MsgRemoveBridgeResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgRemoveBridgeResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgRemoveBridgeResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgRemoveBridgeResponse);
        return message;
    },
};
const baseMsgUpdateToken = { updater: "", denom: "" };
exports.MsgUpdateToken = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.updater !== "") {
            writer.uint32(10).string(message.updater);
        }
        if (message.denom !== "") {
            writer.uint32(18).string(message.denom);
        }
        if (message.updateTokenParams !== undefined) {
            exports.UpdateTokenParams.encode(message.updateTokenParams, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUpdateToken);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.updater = reader.string();
                    break;
                case 2:
                    message.denom = reader.string();
                    break;
                case 3:
                    message.updateTokenParams = exports.UpdateTokenParams.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgUpdateToken);
        message.updater =
            object.updater !== undefined && object.updater !== null
                ? String(object.updater)
                : "";
        message.denom =
            object.denom !== undefined && object.denom !== null
                ? String(object.denom)
                : "";
        message.updateTokenParams =
            object.updateTokenParams !== undefined &&
                object.updateTokenParams !== null
                ? exports.UpdateTokenParams.fromJSON(object.updateTokenParams)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.updater !== undefined && (obj.updater = message.updater);
        message.denom !== undefined && (obj.denom = message.denom);
        message.updateTokenParams !== undefined &&
            (obj.updateTokenParams = message.updateTokenParams
                ? exports.UpdateTokenParams.toJSON(message.updateTokenParams)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseMsgUpdateToken);
        message.updater = (_a = object.updater) !== null && _a !== void 0 ? _a : "";
        message.denom = (_b = object.denom) !== null && _b !== void 0 ? _b : "";
        message.updateTokenParams =
            object.updateTokenParams !== undefined &&
                object.updateTokenParams !== null
                ? exports.UpdateTokenParams.fromPartial(object.updateTokenParams)
                : undefined;
        return message;
    },
};
const baseUpdateTokenParams = {};
exports.UpdateTokenParams = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.isActive !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.isActive }, writer.uint32(10).fork()).ldelim();
        }
        if (message.name !== undefined) {
            wrappers_1.StringValue.encode({ value: message.name }, writer.uint32(26).fork()).ldelim();
        }
        if (message.symbol !== undefined) {
            wrappers_1.StringValue.encode({ value: message.symbol }, writer.uint32(34).fork()).ldelim();
        }
        if (message.decimals !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.decimals }, writer.uint32(42).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseUpdateTokenParams);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.isActive = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 3:
                    message.name = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                case 4:
                    message.symbol = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                case 5:
                    message.decimals = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseUpdateTokenParams);
        message.isActive =
            object.isActive !== undefined && object.isActive !== null
                ? Boolean(object.isActive)
                : undefined;
        message.name =
            object.name !== undefined && object.name !== null
                ? String(object.name)
                : undefined;
        message.symbol =
            object.symbol !== undefined && object.symbol !== null
                ? String(object.symbol)
                : undefined;
        message.decimals =
            object.decimals !== undefined && object.decimals !== null
                ? long_1.default.fromValue(object.decimals)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.isActive !== undefined && (obj.isActive = message.isActive);
        message.name !== undefined && (obj.name = message.name);
        message.symbol !== undefined && (obj.symbol = message.symbol);
        message.decimals !== undefined && (obj.decimals = message.decimals);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = Object.assign({}, baseUpdateTokenParams);
        message.isActive = (_a = object.isActive) !== null && _a !== void 0 ? _a : undefined;
        message.name = (_b = object.name) !== null && _b !== void 0 ? _b : undefined;
        message.symbol = (_c = object.symbol) !== null && _c !== void 0 ? _c : undefined;
        message.decimals =
            object.decimals !== undefined && object.decimals !== null
                ? long_1.default.fromValue(object.decimals)
                : undefined;
        return message;
    },
};
const baseMsgUpdateTokenResponse = {};
exports.MsgUpdateTokenResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUpdateTokenResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgUpdateTokenResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgUpdateTokenResponse);
        return message;
    },
};
const baseMsgAddBridgeAddress = {
    creator: "",
    chainId: long_1.default.UZERO,
    bridgeId: long_1.default.UZERO,
    bridgeAddress: "",
};
exports.MsgAddBridgeAddress = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (!message.chainId.isZero()) {
            writer.uint32(16).uint64(message.chainId);
        }
        if (!message.bridgeId.isZero()) {
            writer.uint32(24).uint64(message.bridgeId);
        }
        if (message.bridgeAddress !== "") {
            writer.uint32(34).string(message.bridgeAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgAddBridgeAddress);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.chainId = reader.uint64();
                    break;
                case 3:
                    message.bridgeId = reader.uint64();
                    break;
                case 4:
                    message.bridgeAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgAddBridgeAddress);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.chainId =
            object.chainId !== undefined && object.chainId !== null
                ? long_1.default.fromString(object.chainId)
                : long_1.default.UZERO;
        message.bridgeId =
            object.bridgeId !== undefined && object.bridgeId !== null
                ? long_1.default.fromString(object.bridgeId)
                : long_1.default.UZERO;
        message.bridgeAddress =
            object.bridgeAddress !== undefined && object.bridgeAddress !== null
                ? String(object.bridgeAddress)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.chainId !== undefined &&
            (obj.chainId = (message.chainId || long_1.default.UZERO).toString());
        message.bridgeId !== undefined &&
            (obj.bridgeId = (message.bridgeId || long_1.default.UZERO).toString());
        message.bridgeAddress !== undefined &&
            (obj.bridgeAddress = message.bridgeAddress);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseMsgAddBridgeAddress);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.chainId =
            object.chainId !== undefined && object.chainId !== null
                ? long_1.default.fromValue(object.chainId)
                : long_1.default.UZERO;
        message.bridgeId =
            object.bridgeId !== undefined && object.bridgeId !== null
                ? long_1.default.fromValue(object.bridgeId)
                : long_1.default.UZERO;
        message.bridgeAddress = (_b = object.bridgeAddress) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseMsgAddBridgeAddressResponse = { id: "" };
exports.MsgAddBridgeAddressResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (message.bridge !== undefined) {
            bridge_1.Bridge.encode(message.bridge, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgAddBridgeAddressResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.bridge = bridge_1.Bridge.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgAddBridgeAddressResponse);
        message.id =
            object.id !== undefined && object.id !== null ? String(object.id) : "";
        message.bridge =
            object.bridge !== undefined && object.bridge !== null
                ? bridge_1.Bridge.fromJSON(object.bridge)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.id !== undefined && (obj.id = message.id);
        message.bridge !== undefined &&
            (obj.bridge = message.bridge ? bridge_1.Bridge.toJSON(message.bridge) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseMsgAddBridgeAddressResponse);
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : "";
        message.bridge =
            object.bridge !== undefined && object.bridge !== null
                ? bridge_1.Bridge.fromPartial(object.bridge)
                : undefined;
        return message;
    },
};
const baseMsgRemoveBridgeAddress = {
    initiator: "",
    chainId: long_1.default.UZERO,
    bridgeId: long_1.default.UZERO,
    bridgeAddress: "",
};
exports.MsgRemoveBridgeAddress = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.initiator !== "") {
            writer.uint32(10).string(message.initiator);
        }
        if (!message.chainId.isZero()) {
            writer.uint32(16).uint64(message.chainId);
        }
        if (!message.bridgeId.isZero()) {
            writer.uint32(24).uint64(message.bridgeId);
        }
        if (message.bridgeAddress !== "") {
            writer.uint32(34).string(message.bridgeAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgRemoveBridgeAddress);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.initiator = reader.string();
                    break;
                case 2:
                    message.chainId = reader.uint64();
                    break;
                case 3:
                    message.bridgeId = reader.uint64();
                    break;
                case 4:
                    message.bridgeAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgRemoveBridgeAddress);
        message.initiator =
            object.initiator !== undefined && object.initiator !== null
                ? String(object.initiator)
                : "";
        message.chainId =
            object.chainId !== undefined && object.chainId !== null
                ? long_1.default.fromString(object.chainId)
                : long_1.default.UZERO;
        message.bridgeId =
            object.bridgeId !== undefined && object.bridgeId !== null
                ? long_1.default.fromString(object.bridgeId)
                : long_1.default.UZERO;
        message.bridgeAddress =
            object.bridgeAddress !== undefined && object.bridgeAddress !== null
                ? String(object.bridgeAddress)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.initiator !== undefined && (obj.initiator = message.initiator);
        message.chainId !== undefined &&
            (obj.chainId = (message.chainId || long_1.default.UZERO).toString());
        message.bridgeId !== undefined &&
            (obj.bridgeId = (message.bridgeId || long_1.default.UZERO).toString());
        message.bridgeAddress !== undefined &&
            (obj.bridgeAddress = message.bridgeAddress);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseMsgRemoveBridgeAddress);
        message.initiator = (_a = object.initiator) !== null && _a !== void 0 ? _a : "";
        message.chainId =
            object.chainId !== undefined && object.chainId !== null
                ? long_1.default.fromValue(object.chainId)
                : long_1.default.UZERO;
        message.bridgeId =
            object.bridgeId !== undefined && object.bridgeId !== null
                ? long_1.default.fromValue(object.bridgeId)
                : long_1.default.UZERO;
        message.bridgeAddress = (_b = object.bridgeAddress) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseMsgRemoveBridgeAddressResponse = { id: "" };
exports.MsgRemoveBridgeAddressResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (message.bridge !== undefined) {
            bridge_1.Bridge.encode(message.bridge, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgRemoveBridgeAddressResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.bridge = bridge_1.Bridge.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgRemoveBridgeAddressResponse);
        message.id =
            object.id !== undefined && object.id !== null ? String(object.id) : "";
        message.bridge =
            object.bridge !== undefined && object.bridge !== null
                ? bridge_1.Bridge.fromJSON(object.bridge)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.id !== undefined && (obj.id = message.id);
        message.bridge !== undefined &&
            (obj.bridge = message.bridge ? bridge_1.Bridge.toJSON(message.bridge) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseMsgRemoveBridgeAddressResponse);
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : "";
        message.bridge =
            object.bridge !== undefined && object.bridge !== null
                ? bridge_1.Bridge.fromPartial(object.bridge)
                : undefined;
        return message;
    },
};
const baseMsgCreateGroup = {
    creator: "",
    name: "",
    chequeTokenSymbol: "",
    oracleId: "",
};
exports.MsgCreateGroup = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.name !== "") {
            writer.uint32(18).string(message.name);
        }
        if (message.chequeTokenSymbol !== "") {
            writer.uint32(26).string(message.chequeTokenSymbol);
        }
        if (message.oracleId !== "") {
            writer.uint32(34).string(message.oracleId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgCreateGroup);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.name = reader.string();
                    break;
                case 3:
                    message.chequeTokenSymbol = reader.string();
                    break;
                case 4:
                    message.oracleId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgCreateGroup);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.name =
            object.name !== undefined && object.name !== null
                ? String(object.name)
                : "";
        message.chequeTokenSymbol =
            object.chequeTokenSymbol !== undefined &&
                object.chequeTokenSymbol !== null
                ? String(object.chequeTokenSymbol)
                : "";
        message.oracleId =
            object.oracleId !== undefined && object.oracleId !== null
                ? String(object.oracleId)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.name !== undefined && (obj.name = message.name);
        message.chequeTokenSymbol !== undefined &&
            (obj.chequeTokenSymbol = message.chequeTokenSymbol);
        message.oracleId !== undefined && (obj.oracleId = message.oracleId);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = Object.assign({}, baseMsgCreateGroup);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.name = (_b = object.name) !== null && _b !== void 0 ? _b : "";
        message.chequeTokenSymbol = (_c = object.chequeTokenSymbol) !== null && _c !== void 0 ? _c : "";
        message.oracleId = (_d = object.oracleId) !== null && _d !== void 0 ? _d : "";
        return message;
    },
};
const baseMsgCreateGroupResponse = {};
exports.MsgCreateGroupResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.tokenGroup !== undefined) {
            group_1.TokenGroup.encode(message.tokenGroup, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgCreateGroupResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.tokenGroup = group_1.TokenGroup.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgCreateGroupResponse);
        message.tokenGroup =
            object.tokenGroup !== undefined && object.tokenGroup !== null
                ? group_1.TokenGroup.fromJSON(object.tokenGroup)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.tokenGroup !== undefined &&
            (obj.tokenGroup = message.tokenGroup
                ? group_1.TokenGroup.toJSON(message.tokenGroup)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseMsgCreateGroupResponse);
        message.tokenGroup =
            object.tokenGroup !== undefined && object.tokenGroup !== null
                ? group_1.TokenGroup.fromPartial(object.tokenGroup)
                : undefined;
        return message;
    },
};
const baseMsgUpdateGroup = { creator: "", groupId: long_1.default.UZERO };
exports.MsgUpdateGroup = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (!message.groupId.isZero()) {
            writer.uint32(16).uint64(message.groupId);
        }
        if (message.updateGroupParams !== undefined) {
            exports.UpdateGroupParams.encode(message.updateGroupParams, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUpdateGroup);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.groupId = reader.uint64();
                    break;
                case 3:
                    message.updateGroupParams = exports.UpdateGroupParams.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgUpdateGroup);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.groupId =
            object.groupId !== undefined && object.groupId !== null
                ? long_1.default.fromString(object.groupId)
                : long_1.default.UZERO;
        message.updateGroupParams =
            object.updateGroupParams !== undefined &&
                object.updateGroupParams !== null
                ? exports.UpdateGroupParams.fromJSON(object.updateGroupParams)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.groupId !== undefined &&
            (obj.groupId = (message.groupId || long_1.default.UZERO).toString());
        message.updateGroupParams !== undefined &&
            (obj.updateGroupParams = message.updateGroupParams
                ? exports.UpdateGroupParams.toJSON(message.updateGroupParams)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseMsgUpdateGroup);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.groupId =
            object.groupId !== undefined && object.groupId !== null
                ? long_1.default.fromValue(object.groupId)
                : long_1.default.UZERO;
        message.updateGroupParams =
            object.updateGroupParams !== undefined &&
                object.updateGroupParams !== null
                ? exports.UpdateGroupParams.fromPartial(object.updateGroupParams)
                : undefined;
        return message;
    },
};
const baseUpdateGroupParams = {};
exports.UpdateGroupParams = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.name !== undefined) {
            wrappers_1.StringValue.encode({ value: message.name }, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseUpdateGroupParams);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.name = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseUpdateGroupParams);
        message.name =
            object.name !== undefined && object.name !== null
                ? String(object.name)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.name !== undefined && (obj.name = message.name);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseUpdateGroupParams);
        message.name = (_a = object.name) !== null && _a !== void 0 ? _a : undefined;
        return message;
    },
};
const baseMsgUpdateGroupResponse = {};
exports.MsgUpdateGroupResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.tokenGroup !== undefined) {
            group_1.TokenGroup.encode(message.tokenGroup, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUpdateGroupResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.tokenGroup = group_1.TokenGroup.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgUpdateGroupResponse);
        message.tokenGroup =
            object.tokenGroup !== undefined && object.tokenGroup !== null
                ? group_1.TokenGroup.fromJSON(object.tokenGroup)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.tokenGroup !== undefined &&
            (obj.tokenGroup = message.tokenGroup
                ? group_1.TokenGroup.toJSON(message.tokenGroup)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseMsgUpdateGroupResponse);
        message.tokenGroup =
            object.tokenGroup !== undefined && object.tokenGroup !== null
                ? group_1.TokenGroup.fromPartial(object.tokenGroup)
                : undefined;
        return message;
    },
};
const baseMsgRegisterToGroup = {
    creator: "",
    groupId: long_1.default.UZERO,
    denom: "",
};
exports.MsgRegisterToGroup = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (!message.groupId.isZero()) {
            writer.uint32(16).uint64(message.groupId);
        }
        if (message.denom !== "") {
            writer.uint32(26).string(message.denom);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgRegisterToGroup);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.groupId = reader.uint64();
                    break;
                case 3:
                    message.denom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgRegisterToGroup);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.groupId =
            object.groupId !== undefined && object.groupId !== null
                ? long_1.default.fromString(object.groupId)
                : long_1.default.UZERO;
        message.denom =
            object.denom !== undefined && object.denom !== null
                ? String(object.denom)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.groupId !== undefined &&
            (obj.groupId = (message.groupId || long_1.default.UZERO).toString());
        message.denom !== undefined && (obj.denom = message.denom);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseMsgRegisterToGroup);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.groupId =
            object.groupId !== undefined && object.groupId !== null
                ? long_1.default.fromValue(object.groupId)
                : long_1.default.UZERO;
        message.denom = (_b = object.denom) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseMsgRegisterToGroupResponse = {};
exports.MsgRegisterToGroupResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgRegisterToGroupResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgRegisterToGroupResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgRegisterToGroupResponse);
        return message;
    },
};
const baseMsgDeregisterFromGroup = {
    creator: "",
    groupId: long_1.default.UZERO,
    denom: "",
};
exports.MsgDeregisterFromGroup = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (!message.groupId.isZero()) {
            writer.uint32(16).uint64(message.groupId);
        }
        if (message.denom !== "") {
            writer.uint32(26).string(message.denom);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgDeregisterFromGroup);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.groupId = reader.uint64();
                    break;
                case 3:
                    message.denom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgDeregisterFromGroup);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.groupId =
            object.groupId !== undefined && object.groupId !== null
                ? long_1.default.fromString(object.groupId)
                : long_1.default.UZERO;
        message.denom =
            object.denom !== undefined && object.denom !== null
                ? String(object.denom)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.groupId !== undefined &&
            (obj.groupId = (message.groupId || long_1.default.UZERO).toString());
        message.denom !== undefined && (obj.denom = message.denom);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseMsgDeregisterFromGroup);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.groupId =
            object.groupId !== undefined && object.groupId !== null
                ? long_1.default.fromValue(object.groupId)
                : long_1.default.UZERO;
        message.denom = (_b = object.denom) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseMsgDeregisterFromGroupResponse = {};
exports.MsgDeregisterFromGroupResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgDeregisterFromGroupResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgDeregisterFromGroupResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgDeregisterFromGroupResponse);
        return message;
    },
};
const baseMsgDepositToGroup = { creator: "" };
exports.MsgDepositToGroup = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.depositCoin !== undefined) {
            coin_1.Coin.encode(message.depositCoin, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgDepositToGroup);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.depositCoin = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgDepositToGroup);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.depositCoin =
            object.depositCoin !== undefined && object.depositCoin !== null
                ? coin_1.Coin.fromJSON(object.depositCoin)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.depositCoin !== undefined &&
            (obj.depositCoin = message.depositCoin
                ? coin_1.Coin.toJSON(message.depositCoin)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseMsgDepositToGroup);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.depositCoin =
            object.depositCoin !== undefined && object.depositCoin !== null
                ? coin_1.Coin.fromPartial(object.depositCoin)
                : undefined;
        return message;
    },
};
const baseMsgDepositToGroupResponse = { groupId: long_1.default.UZERO };
exports.MsgDepositToGroupResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.groupId.isZero()) {
            writer.uint32(8).uint64(message.groupId);
        }
        if (message.tokensDeposited !== undefined) {
            coin_1.Coin.encode(message.tokensDeposited, writer.uint32(18).fork()).ldelim();
        }
        if (message.tokensMinted !== undefined) {
            coin_1.Coin.encode(message.tokensMinted, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgDepositToGroupResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.groupId = reader.uint64();
                    break;
                case 2:
                    message.tokensDeposited = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.tokensMinted = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgDepositToGroupResponse);
        message.groupId =
            object.groupId !== undefined && object.groupId !== null
                ? long_1.default.fromString(object.groupId)
                : long_1.default.UZERO;
        message.tokensDeposited =
            object.tokensDeposited !== undefined && object.tokensDeposited !== null
                ? coin_1.Coin.fromJSON(object.tokensDeposited)
                : undefined;
        message.tokensMinted =
            object.tokensMinted !== undefined && object.tokensMinted !== null
                ? coin_1.Coin.fromJSON(object.tokensMinted)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.groupId !== undefined &&
            (obj.groupId = (message.groupId || long_1.default.UZERO).toString());
        message.tokensDeposited !== undefined &&
            (obj.tokensDeposited = message.tokensDeposited
                ? coin_1.Coin.toJSON(message.tokensDeposited)
                : undefined);
        message.tokensMinted !== undefined &&
            (obj.tokensMinted = message.tokensMinted
                ? coin_1.Coin.toJSON(message.tokensMinted)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseMsgDepositToGroupResponse);
        message.groupId =
            object.groupId !== undefined && object.groupId !== null
                ? long_1.default.fromValue(object.groupId)
                : long_1.default.UZERO;
        message.tokensDeposited =
            object.tokensDeposited !== undefined && object.tokensDeposited !== null
                ? coin_1.Coin.fromPartial(object.tokensDeposited)
                : undefined;
        message.tokensMinted =
            object.tokensMinted !== undefined && object.tokensMinted !== null
                ? coin_1.Coin.fromPartial(object.tokensMinted)
                : undefined;
        return message;
    },
};
const baseMsgWithdrawFromGroup = { creator: "" };
exports.MsgWithdrawFromGroup = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.sourceCoin !== undefined) {
            coin_1.Coin.encode(message.sourceCoin, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgWithdrawFromGroup);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.sourceCoin = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgWithdrawFromGroup);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.sourceCoin =
            object.sourceCoin !== undefined && object.sourceCoin !== null
                ? coin_1.Coin.fromJSON(object.sourceCoin)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.sourceCoin !== undefined &&
            (obj.sourceCoin = message.sourceCoin
                ? coin_1.Coin.toJSON(message.sourceCoin)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseMsgWithdrawFromGroup);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.sourceCoin =
            object.sourceCoin !== undefined && object.sourceCoin !== null
                ? coin_1.Coin.fromPartial(object.sourceCoin)
                : undefined;
        return message;
    },
};
const baseMsgWithdrawFromGroupResponse = { groupId: long_1.default.UZERO };
exports.MsgWithdrawFromGroupResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.groupId.isZero()) {
            writer.uint32(8).uint64(message.groupId);
        }
        if (message.tokensBurnt !== undefined) {
            coin_1.Coin.encode(message.tokensBurnt, writer.uint32(18).fork()).ldelim();
        }
        if (message.tokensWithdrawn !== undefined) {
            coin_1.Coin.encode(message.tokensWithdrawn, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgWithdrawFromGroupResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.groupId = reader.uint64();
                    break;
                case 2:
                    message.tokensBurnt = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.tokensWithdrawn = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgWithdrawFromGroupResponse);
        message.groupId =
            object.groupId !== undefined && object.groupId !== null
                ? long_1.default.fromString(object.groupId)
                : long_1.default.UZERO;
        message.tokensBurnt =
            object.tokensBurnt !== undefined && object.tokensBurnt !== null
                ? coin_1.Coin.fromJSON(object.tokensBurnt)
                : undefined;
        message.tokensWithdrawn =
            object.tokensWithdrawn !== undefined && object.tokensWithdrawn !== null
                ? coin_1.Coin.fromJSON(object.tokensWithdrawn)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.groupId !== undefined &&
            (obj.groupId = (message.groupId || long_1.default.UZERO).toString());
        message.tokensBurnt !== undefined &&
            (obj.tokensBurnt = message.tokensBurnt
                ? coin_1.Coin.toJSON(message.tokensBurnt)
                : undefined);
        message.tokensWithdrawn !== undefined &&
            (obj.tokensWithdrawn = message.tokensWithdrawn
                ? coin_1.Coin.toJSON(message.tokensWithdrawn)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseMsgWithdrawFromGroupResponse);
        message.groupId =
            object.groupId !== undefined && object.groupId !== null
                ? long_1.default.fromValue(object.groupId)
                : long_1.default.UZERO;
        message.tokensBurnt =
            object.tokensBurnt !== undefined && object.tokensBurnt !== null
                ? coin_1.Coin.fromPartial(object.tokensBurnt)
                : undefined;
        message.tokensWithdrawn =
            object.tokensWithdrawn !== undefined && object.tokensWithdrawn !== null
                ? coin_1.Coin.fromPartial(object.tokensWithdrawn)
                : undefined;
        return message;
    },
};
const baseMsgUpdateGroupedTokenConfig = { creator: "", denom: "" };
exports.MsgUpdateGroupedTokenConfig = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.denom !== "") {
            writer.uint32(18).string(message.denom);
        }
        if (message.updateGroupedTokenConfigParams !== undefined) {
            exports.UpdateGroupedTokenConfigParams.encode(message.updateGroupedTokenConfigParams, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUpdateGroupedTokenConfig);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.denom = reader.string();
                    break;
                case 3:
                    message.updateGroupedTokenConfigParams =
                        exports.UpdateGroupedTokenConfigParams.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgUpdateGroupedTokenConfig);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.denom =
            object.denom !== undefined && object.denom !== null
                ? String(object.denom)
                : "";
        message.updateGroupedTokenConfigParams =
            object.updateGroupedTokenConfigParams !== undefined &&
                object.updateGroupedTokenConfigParams !== null
                ? exports.UpdateGroupedTokenConfigParams.fromJSON(object.updateGroupedTokenConfigParams)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.denom !== undefined && (obj.denom = message.denom);
        message.updateGroupedTokenConfigParams !== undefined &&
            (obj.updateGroupedTokenConfigParams =
                message.updateGroupedTokenConfigParams
                    ? exports.UpdateGroupedTokenConfigParams.toJSON(message.updateGroupedTokenConfigParams)
                    : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseMsgUpdateGroupedTokenConfig);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.denom = (_b = object.denom) !== null && _b !== void 0 ? _b : "";
        message.updateGroupedTokenConfigParams =
            object.updateGroupedTokenConfigParams !== undefined &&
                object.updateGroupedTokenConfigParams !== null
                ? exports.UpdateGroupedTokenConfigParams.fromPartial(object.updateGroupedTokenConfigParams)
                : undefined;
        return message;
    },
};
const baseUpdateGroupedTokenConfigParams = {};
exports.UpdateGroupedTokenConfigParams = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.isActive !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.isActive }, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseUpdateGroupedTokenConfigParams);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.isActive = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseUpdateGroupedTokenConfigParams);
        message.isActive =
            object.isActive !== undefined && object.isActive !== null
                ? Boolean(object.isActive)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.isActive !== undefined && (obj.isActive = message.isActive);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseUpdateGroupedTokenConfigParams);
        message.isActive = (_a = object.isActive) !== null && _a !== void 0 ? _a : undefined;
        return message;
    },
};
const baseMsgUpdateGroupedTokenConfigResponse = {};
exports.MsgUpdateGroupedTokenConfigResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.groupedTokenConfig !== undefined) {
            group_1.GroupedTokenConfig.encode(message.groupedTokenConfig, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUpdateGroupedTokenConfigResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.groupedTokenConfig = group_1.GroupedTokenConfig.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgUpdateGroupedTokenConfigResponse);
        message.groupedTokenConfig =
            object.groupedTokenConfig !== undefined &&
                object.groupedTokenConfig !== null
                ? group_1.GroupedTokenConfig.fromJSON(object.groupedTokenConfig)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.groupedTokenConfig !== undefined &&
            (obj.groupedTokenConfig = message.groupedTokenConfig
                ? group_1.GroupedTokenConfig.toJSON(message.groupedTokenConfig)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseMsgUpdateGroupedTokenConfigResponse);
        message.groupedTokenConfig =
            object.groupedTokenConfig !== undefined &&
                object.groupedTokenConfig !== null
                ? group_1.GroupedTokenConfig.fromPartial(object.groupedTokenConfig)
                : undefined;
        return message;
    },
};
class MsgClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.CreateToken = this.CreateToken.bind(this);
        this.SyncToken = this.SyncToken.bind(this);
        this.MintToken = this.MintToken.bind(this);
        this.BindToken = this.BindToken.bind(this);
        this.UnbindToken = this.UnbindToken.bind(this);
        this.LinkToken = this.LinkToken.bind(this);
        this.Withdraw = this.Withdraw.bind(this);
        this.AuthorizeBridge = this.AuthorizeBridge.bind(this);
        this.DeauthorizeBridge = this.DeauthorizeBridge.bind(this);
        this.EditBridgeName = this.EditBridgeName.bind(this);
        this.RemoveBridge = this.RemoveBridge.bind(this);
        this.UpdateToken = this.UpdateToken.bind(this);
        this.AddBridgeAddress = this.AddBridgeAddress.bind(this);
        this.RemoveBridgeAddress = this.RemoveBridgeAddress.bind(this);
        this.CreateGroup = this.CreateGroup.bind(this);
        this.UpdateGroup = this.UpdateGroup.bind(this);
        this.RegisterToGroup = this.RegisterToGroup.bind(this);
        this.DeregisterFromGroup = this.DeregisterFromGroup.bind(this);
        this.DepositToGroup = this.DepositToGroup.bind(this);
        this.WithdrawFromGroup = this.WithdrawFromGroup.bind(this);
        this.UpdateGroupedTokenConfig = this.UpdateGroupedTokenConfig.bind(this);
    }
    CreateToken(request) {
        const data = exports.MsgCreateToken.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.coin.Msg", "CreateToken", data);
        return promise.then((data) => exports.MsgCreateTokenResponse.decode(new minimal_1.default.Reader(data)));
    }
    SyncToken(request) {
        const data = exports.MsgSyncToken.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.coin.Msg", "SyncToken", data);
        return promise.then((data) => exports.MsgSyncTokenResponse.decode(new minimal_1.default.Reader(data)));
    }
    MintToken(request) {
        const data = exports.MsgMintToken.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.coin.Msg", "MintToken", data);
        return promise.then((data) => exports.MsgMintTokenResponse.decode(new minimal_1.default.Reader(data)));
    }
    BindToken(request) {
        const data = exports.MsgBindToken.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.coin.Msg", "BindToken", data);
        return promise.then((data) => exports.MsgBindTokenResponse.decode(new minimal_1.default.Reader(data)));
    }
    UnbindToken(request) {
        const data = exports.MsgUnbindToken.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.coin.Msg", "UnbindToken", data);
        return promise.then((data) => exports.MsgUnbindTokenResponse.decode(new minimal_1.default.Reader(data)));
    }
    LinkToken(request) {
        const data = exports.MsgLinkToken.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.coin.Msg", "LinkToken", data);
        return promise.then((data) => exports.MsgLinkTokenResponse.decode(new minimal_1.default.Reader(data)));
    }
    Withdraw(request) {
        const data = exports.MsgWithdraw.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.coin.Msg", "Withdraw", data);
        return promise.then((data) => exports.MsgWithdrawResponse.decode(new minimal_1.default.Reader(data)));
    }
    AuthorizeBridge(request) {
        const data = exports.MsgAuthorizeBridge.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.coin.Msg", "AuthorizeBridge", data);
        return promise.then((data) => exports.MsgAuthorizeBridgeResponse.decode(new minimal_1.default.Reader(data)));
    }
    DeauthorizeBridge(request) {
        const data = exports.MsgDeauthorizeBridge.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.coin.Msg", "DeauthorizeBridge", data);
        return promise.then((data) => exports.MsgDeauthorizeBridgeResponse.decode(new minimal_1.default.Reader(data)));
    }
    EditBridgeName(request) {
        const data = exports.MsgEditBridgeName.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.coin.Msg", "EditBridgeName", data);
        return promise.then((data) => exports.MsgEditBridgeNameResponse.decode(new minimal_1.default.Reader(data)));
    }
    RemoveBridge(request) {
        const data = exports.MsgRemoveBridge.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.coin.Msg", "RemoveBridge", data);
        return promise.then((data) => exports.MsgRemoveBridgeResponse.decode(new minimal_1.default.Reader(data)));
    }
    UpdateToken(request) {
        const data = exports.MsgUpdateToken.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.coin.Msg", "UpdateToken", data);
        return promise.then((data) => exports.MsgUpdateTokenResponse.decode(new minimal_1.default.Reader(data)));
    }
    AddBridgeAddress(request) {
        const data = exports.MsgAddBridgeAddress.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.coin.Msg", "AddBridgeAddress", data);
        return promise.then((data) => exports.MsgAddBridgeAddressResponse.decode(new minimal_1.default.Reader(data)));
    }
    RemoveBridgeAddress(request) {
        const data = exports.MsgRemoveBridgeAddress.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.coin.Msg", "RemoveBridgeAddress", data);
        return promise.then((data) => exports.MsgRemoveBridgeAddressResponse.decode(new minimal_1.default.Reader(data)));
    }
    CreateGroup(request) {
        const data = exports.MsgCreateGroup.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.coin.Msg", "CreateGroup", data);
        return promise.then((data) => exports.MsgCreateGroupResponse.decode(new minimal_1.default.Reader(data)));
    }
    UpdateGroup(request) {
        const data = exports.MsgUpdateGroup.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.coin.Msg", "UpdateGroup", data);
        return promise.then((data) => exports.MsgUpdateGroupResponse.decode(new minimal_1.default.Reader(data)));
    }
    RegisterToGroup(request) {
        const data = exports.MsgRegisterToGroup.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.coin.Msg", "RegisterToGroup", data);
        return promise.then((data) => exports.MsgRegisterToGroupResponse.decode(new minimal_1.default.Reader(data)));
    }
    DeregisterFromGroup(request) {
        const data = exports.MsgDeregisterFromGroup.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.coin.Msg", "DeregisterFromGroup", data);
        return promise.then((data) => exports.MsgDeregisterFromGroupResponse.decode(new minimal_1.default.Reader(data)));
    }
    DepositToGroup(request) {
        const data = exports.MsgDepositToGroup.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.coin.Msg", "DepositToGroup", data);
        return promise.then((data) => exports.MsgDepositToGroupResponse.decode(new minimal_1.default.Reader(data)));
    }
    WithdrawFromGroup(request) {
        const data = exports.MsgWithdrawFromGroup.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.coin.Msg", "WithdrawFromGroup", data);
        return promise.then((data) => exports.MsgWithdrawFromGroupResponse.decode(new minimal_1.default.Reader(data)));
    }
    UpdateGroupedTokenConfig(request) {
        const data = exports.MsgUpdateGroupedTokenConfig.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.coin.Msg", "UpdateGroupedTokenConfig", data);
        return promise.then((data) => exports.MsgUpdateGroupedTokenConfigResponse.decode(new minimal_1.default.Reader(data)));
    }
}
exports.MsgClientImpl = MsgClientImpl;
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
